import axios from "axios";
import store from "../store";
import router from "../router";

//const endpoint = "https://albatros-server.dev.ibsw.fr/api";

const endpoint = process.env.VUE_APP_API_ENDPOINT;

export const instance = axios.create({
  baseURL: endpoint,
  timeout: 100000,
});

// Add Authorization header for each request
instance.interceptors.request.use(
  function(config) {
    config.headers.Authorization = `Bearer ${localStorage.getItem("jwt")}`;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// Logout if we have a 401 error
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // Status 401, logout
      if (error.response.status === 401) {
        store
          .dispatch("user/logout")
          .then(() => {
            router.push({ name: "LoginPage" });
          })
          .catch(() => {
            router.push({ name: "LoginPage" });
          });
      }
    }

    throw error;
  }
);

export default instance;
